import { NgModule } from "@angular/core";
import { ResizableDirective } from "./directive/resizable.directive";

@NgModule({
    imports: [],
    declarations: [ResizableDirective],
    exports: [ResizableDirective],
})
export class ResizableModule {}
